import React from 'react';
import { useTheme } from '../../DataStore/ThemeContext';
import { useStudent } from '../../DataStore/StudentContext';
import ActivityLoader from '../Common/ActivityLoader';
import functions from '../../util/functions';

const FileSection = ({ files = [] }) => {

  const {openSettings} = useTheme();
  const { studentId, setDeleteFile } = useStudent();

  const getFileIcon = (filename) => {
    const ext = filename.split('.').pop().toLowerCase();
    switch (ext) {
      case 'pdf': return 'fa-file-pdf text-danger';
      case 'doc':
      case 'docx': return 'fa-file-word text-primary';
      case 'xls':
      case 'xlsx': return 'fa-file-excel text-success';
      case 'jpg':
      case 'jpeg':
      case 'png': return 'fa-file-image text-warning';
      case 'zip':
      case 'rar': return 'fa-file-archive text-muted';
      default: return 'fa-file text-secondary';
    }
  };

  const handleFileUpload = () => {
    openSettings('Upload File', 'NewStudentFile', studentId);
  }

  return (
    <div className="card shadow-sm">
      <div className="card-header bg-white d-flex justify-content-between align-items-center">
        <h6 className="card-title mb-0">
          <i className="fa fa-paperclip text-primary mr-2"></i>
          Student Files
        </h6>
        <button className="btn btn-sm btn-outline-primary" onClick={handleFileUpload}>
          <i className="fa fa-upload"></i> Upload File
        </button>
      </div>
      <div className="card-body p-0">
        {files !== '404' ? (
          <ul className="list-group list-group-flush">
            {Array.isArray(files) ? files.map(file => (
              <li key={file.id} className="list-group-item d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <i className={`fa ${getFileIcon(file.file_path)} fa-lg mr-3`}></i>
                  <div>
                    <div className="text-truncate" style={{ maxWidth: '250px' }} title={file.file_name}>
                      {file.file_name}
                    </div>
                    <small className="text-muted">Uploaded on {functions.formatDate(file.created_at)}</small>
                  </div>
                </div>
                <div className="btn-group btn-group-sm">
                  <a href={file.file_path} target="_blank" rel="noopener noreferrer" className="btn btn-outline-info" title="View">
                    <i className="fa fa-eye"></i>
                  </a>
                  <a href={file.file_path} download className="btn btn-outline-success" title="Download">
                    <i className="fa fa-download"></i>
                  </a>
                  <button className="btn btn-outline-danger" title="Delete" onClick={() => setDeleteFile({ show: true, file })}>
                    <i className="fa fa-trash-alt"></i>
                  </button>
                </div>
              </li>
            )): <li><ActivityLoader /></li>}
          </ul>
        ) : (
          <p className="text-muted p-3 mb-0">No student files uploaded.</p>
        )}
      </div>
    </div>
  );
};

export default FileSection;
